import React, { useState } from "react";
import gql from "graphql-tag";
import { useQuery, useMutation } from "react-apollo";
import { Row, Col } from "reactstrap";
import { serverUrl } from "../../../../libs/Apollo";

const AttendanceStats = (props) => {
  const StatsAttendance = gql`
    {
      getWorstAttendance {
        user_code
        fullname
        count
        days_active
        foto
      }

      getBestAttendance {
        user_code
        fullname
        count
        days_active
        foto
      }
    }
  `;

  const { data, loading, error, refetch } = useQuery(StatsAttendance);

  return (
    <>
      <br />
      <div className="section p5">
        <div className="sectioncontent">
          <h5 className="">Attendance Stats</h5>
          <Row>
            <Col md="12">
              <div className="section p5">
                <div className="sectioncontent">
                  <h6 className="blocktext" style={{ borderColor: "#27ae60" }}>
                    Best Attendance - Last six months
                  </h6>
                  <Row className="card-container">
                    {data
                      ? data.getBestAttendance.map((best, x) => {
                          return (
                            <Col md="3" className="p-0 mb-1">
                              <AttendanceStatEntry
                                name={best.fullname}
                                // navigate={props.history.push}
                                absence={best.count}
                                percentage={
                                  (best.count / best.days_active) * 100
                                }
                                image={
                                  best.foto === ""
                                    ? require("../../../../images/user.png")
                                    : `${serverUrl}/employee_profile/file/${best.foto}`
                                }
                                color="green"
                              />
                            </Col>
                          );
                        })
                      : null}

                    {data && data.getBestAttendance.length === 0 ? (
                      <div className="text-center text-muted">
                        <h4>No Best Attendance</h4>
                      </div>
                    ) : null}
                  </Row>
                </div>
              </div>
            </Col>
            <Col md="6" />
          </Row>
          <br />
          <Row>
            <Col md="12">
              <div className="section p5">
                <div className="sectioncontent">
                  <h6 className="blocktext" style={{ borderColor: "#c0392b" }}>
                    Worst Attendance - This month
                  </h6>
                  <Row className="card-container">
                    {data
                      ? data.getWorstAttendance.map((worst, x) => {
                          return (
                            <Col md="3" className="p-0 mb-1">
                              <AttendanceStatEntry
                                name={worst.fullname}
                                // navigate={props.history.push}
                                absence={worst.count}
                                percentage={
                                  (worst.count / worst.days_active) * 100
                                }
                                image={
                                  worst.foto === ""
                                    ? require("../../../../images/user.png")
                                    : `${serverUrl}/employee_profile/file/${worst.foto}`
                                }
                                color="red"
                              />
                            </Col>
                          );
                        })
                      : null}
                    {data && data.getWorstAttendance.length === 0 ? (
                      <div className="text-center text-muted">
                        <h4>No Worst Attendance</h4>
                      </div>
                    ) : null}
                  </Row>
                </div>
              </div>
            </Col>
            <Col md="6" />
          </Row>
        </div>
      </div>
    </>
  );
};

export default AttendanceStats;

const AttendanceStatEntry = (props) => {
  const { name, percentage, image, absence, color } = props;
  // console.log(name.split(0,15));
  return (
    <div
      className={"attendancelisting " + color}
      onClick={() => {
        props.navigate("/profile/13/info");
      }}
    >
      <div className="attendancephoto">
        <img src={image} alt="" className="startImage" />
      </div>
      <div className="attendanceinfo">
        <h6>{name.length > 20 ? name.slice(0, 17) + "..." : name}</h6>
        <span>{absence} Absence this month</span>
        <span>{percentage}% Attendance</span>
      </div>
    </div>
  );
};
